import { type RefObject, useEffect, useState } from "react";
export const useScroll = <T extends HTMLElement>(ref: RefObject<T | null>) => {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el != null) {
      const cb = (event: Event) => setScroll((event.currentTarget as T).scrollTop > 0);
      el.addEventListener("scroll", cb, { passive: true });
      setScroll(el.scrollTop > 0);
      return () => el.removeEventListener("scroll", cb);
    }
    return undefined;
  }, [ref]);

  return scroll;
};
